import { render } from "./HdButton.vue?vue&type=template&id=5c9969f8"
import script from "./HdButton.vue?vue&type=script&lang=js"
export * from "./HdButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__